import React from "react";
import { Button, Col, Modal, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Text, Title } = Typography;
const BitelModalFail = ({ message, title, visible, handleOk, handleCancel }) => {
  const { t } = useTranslation();
  return (
    <Modal
      className="page-modal"
      centered
      maskClosable={false}
      visible={visible}
      width={"sm"}
      onCancel={handleCancel}
      footer={[
        <Row justify="center" key={1}>
          <Col md={18}>
            <Button
              className="page-modal-button"
              key="back"
              onClick={handleOk}
            >
              {t("modal.try_again")}
            </Button>
          </Col>
        </Row>,
      ]}
    >
      <Row justify="center">
        <Col md={18}>
          <Title level={3} className="page-modal-title page-modal-title-fail">
            {title}
          </Title>
          <Text className="page-modal-content">
            {message}
          </Text>
        </Col>
      </Row>
    </Modal>
  );
};

export default BitelModalFail;
